module.exports = __webpack_public_path__ + "static/media/information.bed71c46.svg";